<template lang="pug">

div

    //- Navigation
    navigation(@toggle="$emit('toggle')")

    //- Headline
    //- .ui.attached.segment
    //-     .ui.two.column.centered.middle.aligned.grid
    //-         .column: h2.ui.header
    //-             i.mail.bulk.icon
    //-             .content Produkte
    //-         .ui.form.column
    //-             input(type='text' placeholder='Ihr Suchbegriff')

    //- Filter
    .ui.secondary
        .ui.labels
            router-link.ui.label(v-bind:to='{ name: "products" }' exact)
                | Eingestellt:
                .ui.detail {{ counts.open || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "IN_PROCESS" }}' exact)
                | In Bearbeitung:
                .ui.detail {{ counts.inProcess || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "EXPIRED" }}' exact)
                | Preise abgelaufen:
                .ui.detail {{ counts.expired || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "OFFER_CONFIRMED" }}' exact)
                | Bestätigt:
                .ui.detail {{ counts.offerConfirmed || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "IN_PRINT" }}' exact)
                | Im Druck:
                .ui.detail {{ counts.inPrint || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "DELIVERED" }}' exact)
                | Kürzlich ausgeliefert:
                .ui.detail {{ counts.delivered || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "CANCELED" }}' exact)
                | Storniert:
                .ui.detail {{ counts.canceled || '0' }}
            router-link.ui.label(v-bind:to='{ name: "products", query: { status: "ALL" }}' exact)
                | Alle:
                .ui.detail {{ counts.total }}
    
    //- Message wenn keine Produkte gefunden
    .ui.bottom.info.icon.message(v-if='productModels.length === 0')
        i.info.circle.icon
        .content: .header Keine Produkte gefunden

    //- Produkte
    product-table.ui.segment(
        v-bind:campaign-models='campaigns'
        v-bind:media-production-person-models='mediaProductionPersons'
        v-bind:media-production-user-models='mediaProductionUsers'
        v-bind:product-models='paginatedProductModels'
        v-bind:sort-ascending='sortAscending'
        v-bind:variant-models='variantModels'
        v-on:toggle-sort='sortAscending = !sortAscending'
        v-else
    )

    //- Pagination
    .ui.bottom.secondary(v-if='productModels.length > 0')
        .ui.two.column.grid
            .middle.aligned.column
                .ui.form
                    .inline.fields(style='margin: 0')
                        label Zeilen pro Seite:
                        .field
                            select.ui.selection.dropdown(ref='pageSizeDropdown')
                                option(v-for='n in pageSizeOptions' v-bind:key='n' v-bind:value='n') {{ n }}
            .right.aligned.middle.aligned.column(v-if='totalPages > 1')
                .ui.pagination.menu
                    a.icon.item(v-bind:class='{ disabled: currentPage === 1 }' v-on:click='currentPage > 1 && (currentPage -= 1)')
                        i.left.chevron.icon
                    a.item(
                        v-for='page in totalPages'
                        v-bind:key='page'
                        v-bind:class='{ active: page === currentPage }'
                        v-on:click='currentPage = page'
                    ) {{ page }}
                    a.icon.item(v-bind:class='{ disabled: currentPage === totalPages }' v-on:click='currentPage < totalPages && (currentPage += 1)')
                        i.right.chevron.icon

</template>

<script>
    import * as R from 'ramda'
    import { get_status_value_by_value } from '@/utils/product'
    import store from '@/store'
    import Navigation from '@/components/products/Navigation'
    import ProductTable from '@/components/products/Table'

    // Lädt alle nötigen Relationen für ein einzelnes Produkt.
    // Statt breiter product-scoped Queries (GET /products/:id/users?size=999) werden
    // gezielt einzelne Datensätze per ID geladen – diese profitieren vom action-helpers-Cache:
    // Erscheint derselbe mediaProduction-User auf mehreren Produkten der Seite, wird der
    // zweite Request aus dem 5-Sekunden-Cache bedient.
    async function load_product_relations(productModel) {
        // MediaProduction-User laden, danach dessen Person (chained, da wir die Person-ID
        // erst nach dem User-Load kennen: product.mediaProduction → user.person)
        const userAndPersonPromise = productModel.mediaProduction
            ? store.dispatch('users/loadOne', { id: productModel.mediaProduction })
                .then(user => (user && user.person)
                    ? store.dispatch('persons/loadOne', { id: user.person })
                    : null
                )
            : Promise.resolve()

        return await Promise.all([

            userAndPersonPromise,

            // Unternehmen laden (loadOne – bereits gecacht nach erstem Aufruf)
            store.dispatch('companies/loadOne', { id: productModel.company }),

            // Varianten laden (IDs bereits im product.variants vorhanden, aber
            // loadAllByProductId bleibt 1 Request statt N×loadOne)
            store.dispatch('variants/loadAllByProductId', { productId: productModel.id }),

            // ggf. Kampagne laden
            R.when(R.is(Number),
                campaignId => store.dispatch('campaigns/loadOne', { id: campaignId }),
                productModel.campaign
            )

        ])
    }

    // Lädt eine Seite Produkte + deren Relationen und gibt die Produkte zurück
    async function load_page($route, { page = 0, size = 25, sortDirection = 'desc' } = {}) {
        const status = get_status_value_by_value($route.query.status)
        const products = await store.dispatch('products/loadPage', { page, size, status, sortDirection })
        await Promise.all(products.map(load_product_relations))
        return products
    }

    //noinspection JSUnusedGlobalSymbols,JSUnusedLocalSymbols
    export default {

        beforeRouteEnter(to, from, next) {
            load_page(to).then(products => next(vm => { vm.pageProducts = products }))
        },

        beforeRouteUpdate(to, from, next) {
            this._routeChanging = true
            this.currentPage = 1
            load_page(to, { size: this.itemsPerPage, sortDirection: this.sortAscending ? 'asc' : 'desc' })
                .then(products => {
                    this.pageProducts = products
                    this._routeChanging = false
                    next()
                })
        },

        components: { Navigation, ProductTable },

        created() {
            // Nicht-reaktives Flag, um ungewollte Watcher-Auslösung bei Route-Wechsel zu verhindern
            this._routeChanging = false
            this.$root.$on('products:refresh', this.loadCurrentPage)
        },

        mounted() {
            this._initDropdown()
        },

        updated() {
            this._initDropdown()
        },

        beforeDestroy() {
            this.$root.$off('products:refresh', this.loadCurrentPage)
        },

        data() {
            return {
                currentPage: 1,
                itemsPerPage: 25,
                pageProducts: [],
                pageSizeOptions: [25, 50, 100, 250],
                sortAscending: false
            }
        },

        watch: {
            currentPage() {
                if (!this._routeChanging) {
                    this.loadCurrentPage()
                }
            },
            itemsPerPage() {
                if (this.currentPage === 1) {
                    this.loadCurrentPage()
                } else {
                    this.currentPage = 1  // löst currentPage-Watcher aus
                }
            },
            sortAscending() {
                this.loadCurrentPage()
            }
        },

        methods: {
            _initDropdown() {
                const el = this.$refs.pageSizeDropdown
                if (!el || $(el).data('module-dropdown')) return
                $(el).dropdown({
                    onChange: (value) => {
                        const n = parseInt(value, 10)
                        if (n !== this.itemsPerPage) {
                            this.itemsPerPage = n
                            this.currentPage = 1
                        }
                    }
                })
            },

            async loadCurrentPage() {
                const status = get_status_value_by_value(this.$route.query.status)
                const products = await store.dispatch('products/loadPage', {
                    page: this.currentPage - 1,
                    size: this.itemsPerPage,
                    status,
                    sortDirection: this.sortAscending ? 'asc' : 'desc',
                })
                await Promise.all(products.map(load_product_relations))
                this.pageProducts = products
            }
        },

        computed: {

            campaigns() {
                return R.compose(

                    // Nicht gefunden Kampagnen ausfiltern
                    R.reject(R.isNil),

                    // Kampagne holen
                    R.map(campaignId => store.getters['campaigns/byId'](campaignId)),

                    // Kampagnen-ID auslesen
                    R.map(R.prop('campaign'))

                )(this.productModels)
            },

            counts() {
                return store.getters['products/counts']
            },

            mediaProductionPersons() {
                return R.map(({ person }) => store.getters['persons/byId'](person), R.reject(R.isNil, this.mediaProductionUsers))
            },

            mediaProductionUsers() {
                return R.map(({ mediaProduction }) => store.getters['users/byId'](mediaProduction), this.productModels)
            },

            productModels() {
                return this.pageProducts
            },

            variantModels() {
                return store.getters['variants/all']
            },

            totalPages() {
                const status = get_status_value_by_value(this.$route.query.status)
                const c = this.counts
                const countByStatus = {
                    ALL:                c.total,
                    OPEN:               c.open,
                    IN_PROCESS:         c.inProcess,
                    CANCELED:           c.canceled,
                    DELIVERED:          c.delivered,
                    OFFER_CONFIRMED:    c.offerConfirmed,
                    IN_PRINT:           c.inPrint,
                    OFFERS_AVAILABLE:   c.offersAvailable,
                    PRODUCTION_RELEASE: c.productionRelease,
                    EXPIRED:            c.expired,
                }
                const total = countByStatus[status] || c.total || 0
                return Math.ceil(total / this.itemsPerPage)
            },

            paginatedProductModels() {
                // Produkte wurden bereits server-seitig paginiert
                return this.productModels
            }

        }

    }
</script>


